module.exports = __webpack_public_path__ + "img/bnc.c35aca40.png";